import React, { Component } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";

// import MUI
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import Paper from "@material-ui/core/Paper";
import Edit from "@material-ui/icons/Edit";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Cancel from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";

import { getInstrumentsRequest, editInstrumentRequest } from "../../store/actions/instruments";

import Layout from "../../components/Layout";

import {
  TableWrapper,
  MUITableRow,
  MUITableCell,
} from "../../components/Mui";

import {
  ControlBnts,
  MUITextField,
} from "./styles";

class InstrumentsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idOfEditableItem: null,
      editForm: {
        title: "",
      }
    };
  }

  handleEditItem = item => {
    this.setState({
      idOfEditableItem: item.id,
      editForm: { title: item.title },
    });
  };

  cancelEditItem = () => this.setState({ idOfEditableItem: null });

  handleInputChange = event => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      editForm: {
        ...prevState.editForm,
        [name]: value
      }
    }));
  };

  handleSaveItem = () => {
    const { idOfEditableItem, editForm } = this.state;

    this.props.editInstrument({
      id: idOfEditableItem,
      data: editForm,
    });
    this.cancelEditItem();
  };

  componentDidMount() {
    const { getInstruments } = this.props;

    getInstruments({});
  }

  render() {
    const { idOfEditableItem, editForm } = this.state;
    const { items } = this.props

    const sortedItems = items.sort((a, b) => a.id > b.id)

    return (
      <Layout fullScreen title="Instruments">
        <TableWrapper>
          <Paper>
            <Table>
              <TableHead>
                <MUITableRow>
                  <MUITableCell width="4%">ID</MUITableCell>
                  <MUITableCell width="36%" padding="none">Title</MUITableCell>
                  <MUITableCell width="25%">InsertedAt</MUITableCell>
                  <MUITableCell width="25%">UpdatedAt</MUITableCell>
                  <MUITableCell width="10%" />
                </MUITableRow>
              </TableHead>
              <TableBody>
                {sortedItems.length ? sortedItems.map(item => (
                  <MUITableRow
                    hover={idOfEditableItem !== item.id}
                    key={item.id}
                  >
                    <MUITableCell>{item.id}</MUITableCell>
                    <MUITableCell padding="none" style={{ textTransform: 'none' }}>
                      {idOfEditableItem === item.id ? (
                        <MUITextField
                          name="title"
                          value={editForm.title}
                          type="text"
                          onChange={this.handleInputChange}
                          variant="outlined"
                        />
                      ) : (
                        item.title
                      )}
                    </MUITableCell>
                    <MUITableCell>{format(new Date(item.inserted_at), "MM/dd/yyyy HH:mm:ss")}&nbsp;UTC</MUITableCell>
                    <MUITableCell>{format(new Date(item.updated_at), "MM/dd/yyyy HH:mm:ss")}&nbsp;UTC</MUITableCell>
                    <MUITableCell padding="none">
                      <ControlBnts>
                        {idOfEditableItem === item.id ? (
                          <>
                            <IconButton onClick={this.handleSaveItem}>
                              <CheckCircle />
                            </IconButton>
                            <IconButton onClick={this.cancelEditItem}>
                              <Cancel />
                            </IconButton>
                          </>
                        ) : (
                          <IconButton onClick={() => this.handleEditItem(item)} >
                            <Edit />
                          </IconButton>
                        )}
                      </ControlBnts>
                    </MUITableCell>
                  </MUITableRow >
                )) : null}
              </TableBody >
            </Table>
          </Paper>
        </TableWrapper>
      </Layout >
    );
  }
}

const mapState = (state) => ({
  items: state.instruments
});

const mapDispatch = {
  getInstruments: getInstrumentsRequest,
  editInstrument: editInstrumentRequest
};

export default connect(mapState, mapDispatch)(InstrumentsPage);
